import { createRoot } from "@wordpress/element";
import App from "./components/App";

document
	.querySelectorAll(".wp-block-world-world-forecast-card")
	.forEach((el) => {
		const root = el.querySelector(".world-forecast-card__app");
		if (root) {
			createRoot(root).render(<App />);
		}
	});
